document.addEventListener("DOMContentLoaded", () => {
  const root = document.querySelector("[data-cm-mobile-root]");
  if (!root) return;

  const toggle = root.querySelector("[data-cm-mobile-toggle]");
  const panel = root.querySelector("[data-cm-mobile-panel]");
  const closeBtn = root.querySelector("[data-cm-mobile-close]");
  const panelInner = root.querySelector(".cm-mobile-panel__inner");

  // Desktop wrapper
  const desktopWrapper = document.querySelector(".cm-wrapper");

  // Global overlay
  const overlay = document.querySelector(".cm-overlay");

  /* =======================
     HELPERS
     ======================= */
  const activateOverlay = () => overlay?.classList.add("active");
  const deactivateOverlay = () => overlay?.classList.remove("active");

  /* =======================
     OPEN / CLOSE FUNCTIONS
     ======================= */
  const openMobile = () => {
    panel.classList.add("cm-mobile-panel--open");
    document.body.classList.add("cm-mobile-open");
    activateOverlay();
  };

  const closeMobile = () => {
    panel.classList.remove("cm-mobile-panel--open");
    document.body.classList.remove("cm-mobile-open");
    deactivateOverlay();
  };

  const openDesktop = () => {
    desktopWrapper?.classList.add("cyber-hero--open");
    document.body.classList.add("cm-open");
    activateOverlay();
  };

  const closeDesktop = () => {
    desktopWrapper?.classList.remove("cyber-hero--open");
    document.body.classList.remove("cm-open");
    deactivateOverlay();
  };

  /* =======================
     TOGGLE CLICK
     ======================= */
    toggle?.addEventListener("click", (e) => {
    e.stopPropagation();
    const isMobile = window.matchMedia("(max-width: 768px)").matches;

    if (isMobile) {
        const isOpen = panel.classList.contains("cm-mobile-panel--open");
        isOpen ? closeMobile() : openMobile();
    } else {
        const isOpen = desktopWrapper?.classList.contains("cyber-hero--open");
        isOpen ? closeDesktop() : openDesktop();
    }
    });


  /* =======================
     MOBILE CLOSE BUTTON
     ======================= */
  closeBtn?.addEventListener("click", (e) => {
    e.stopPropagation();
    closeMobile();
  });

  /* =======================
     MOBILE CLOSE ON OUTSIDE CLICK
     ======================= */
  document.addEventListener("click", (e) => {
    if (!panel.classList.contains("cm-mobile-panel--open")) return;

    const clickedInside = panelInner.contains(e.target);
    const clickedToggle = toggle.contains(e.target);

    if (!clickedInside && !clickedToggle) {
      closeMobile();
    }
  });

  /* =======================
     ESC (Mobile)
     ======================= */
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") closeMobile();
  });

  /* =======================
     COPY CODES (Mobile)
     ======================= */
  const tiers = root.querySelectorAll(".cm-mobile-tier");

  tiers.forEach((tier) => {
    tier.addEventListener("click", () => {
      const codeEl = tier.querySelector(".cm-mobile-tier__code-label");
      if (!codeEl) return;

      const rawText = codeEl.textContent.trim();
      const code = rawText.split(":").pop().trim();

      copyToClipboard(code);
    });
  });
});
